import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Building2, Users, LayoutDashboard, LogOut, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import { useQueryClient } from '@tanstack/react-query';
import api from '@/lib/axios';
import { useAuthStore } from '@/store/auth.store';
import logoMark from '@/assets/logo.svg';

const NAV_ITEMS = [
  { to: '/super-admin',          label: 'Dashboard',  icon: LayoutDashboard, end: true },
  { to: '/super-admin/clinicas', label: 'Clínicas',   icon: Building2 },
  { to: '/super-admin/medicos',  label: 'Médicos',    icon: Users },
];

export function SuperAdminLayout() {
  const navigate = useNavigate();
  const { logout, usuario } = useAuthStore();
  const qc = useQueryClient();

  async function handleLogout() {
    try { await api.post('/api/auth/logout'); } catch { /* ignore */ }
    qc.clear();
    logout();
    navigate('/login');
  }

  return (
    <div className="flex h-screen bg-slate-950">
      {/* Sidebar */}
      <aside className="flex flex-col w-56 shrink-0 bg-slate-900 border-r border-slate-800 p-4 gap-6">
        {/* Logo + badge */}
        <div className="flex items-center gap-2 px-1 pt-1">
          <img src={logoMark} alt="Anik" className="h-7 w-7" />
          <div>
            <span className="text-white font-bold text-sm tracking-wide">anik</span>
            <div className="flex items-center gap-1 mt-0.5">
              <ShieldCheck size={10} className="text-amber-400" />
              <span className="text-amber-400 text-[10px] font-semibold uppercase tracking-widest">Super Admin</span>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex flex-col gap-1 flex-1">
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-amber-500 text-slate-900'
                    : 'text-slate-400 hover:text-white hover:bg-slate-800'
                }`
              }
            >
              <item.icon size={16} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* User info + logout */}
        <div className="border-t border-slate-800 pt-4 space-y-2">
          <p className="text-xs text-slate-500 truncate px-1">{usuario?.email}</p>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 w-full px-3 py-2 rounded-xl text-slate-400 hover:text-white hover:bg-slate-800 text-sm transition-colors"
          >
            <LogOut size={15} />
            Cerrar sesión
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-slate-950 p-8">
        <Outlet />
      </main>
    </div>
  );
}
